import { Action } from '@ngrx/store';
import { UserInvitation } from '@model';

export enum ManagerCompanyInvitationActionTypes {
  BulkCreateManagerCompanyInvitations = '[ManagerCompanyInvitation] Bulk create',
  BulkCreateManagerCompanyInvitationsSuccess = '[ManagerCompanyInvitation] Bulk create success',
  BulkCreateManagerCompanyInvitationsFail = '[ManagerCompanyInvitation] Bulk create fail',

  ManagerCompanyInvitationsLoadData = '[ManagerCompanyInvitations] Load',
  ManagerCompanyInvitationsLoadSuccess = '[ManagerCompanyInvitations] Load success',
  ManagerCompanyInvitationsLoadFail = '[ManagerCompanyInvitations] Load fail',

  ManagerCompanyInvitationRemove = '[ManagerCompanyInvitation] Remove',
  ManagerCompanyInvitationRemoveSuccess = '[ManagerCompanyInvitation] Remove success',
  ManagerCompanyInvitationRemoveFail = '[ManagerCompanyInvitation] Remove fail',

  ManagerCompanyInvitationReSend = '[ManagerCompanyInvitation] ReSend',
  ManagerCompanyInvitationReSendSuccess = '[ManagerCompanyInvitation] ReSend success',
  ManagerCompanyInvitationReSendFail = '[ManagerCompanyInvitation] ReSend fail',

  ManagerCompanyInvitationUpdate = '[ManagerCompanyInvitation] Update'
}

export class BulkCreateManagerCompanyInvitations implements Action {
  readonly type = ManagerCompanyInvitationActionTypes.BulkCreateManagerCompanyInvitations;
  constructor(public payload: UserInvitation[]) {}
}
export class BulkCreateManagerCompanyInvitationsSuccess implements Action {
  readonly type = ManagerCompanyInvitationActionTypes.BulkCreateManagerCompanyInvitationsSuccess;
  constructor(public payload: UserInvitation[]) {}
}
export class BulkCreateManagerCompanyInvitationsFail implements Action {
  readonly type = ManagerCompanyInvitationActionTypes.BulkCreateManagerCompanyInvitationsFail;
  constructor(public payload: any) {}
}

export class ManagerCompanyInvitationsLoadData implements Action {
  readonly type = ManagerCompanyInvitationActionTypes.ManagerCompanyInvitationsLoadData;
  constructor(public payload: number) {}
}

export class ManagerCompanyInvitationsLoadSuccess implements Action {
  readonly type = ManagerCompanyInvitationActionTypes.ManagerCompanyInvitationsLoadSuccess;
  constructor(public payload: UserInvitation[]) {}
}

export class ManagerCompanyInvitationsLoadFail implements Action {
  readonly type = ManagerCompanyInvitationActionTypes.ManagerCompanyInvitationsLoadFail;
  constructor(public payload: any) {}
}

export class ManagerCompanyInvitationRemove implements Action {
  readonly type = ManagerCompanyInvitationActionTypes.ManagerCompanyInvitationRemove;
  constructor(public payload: UserInvitation) {}
}

export class ManagerCompanyInvitationRemoveSuccess implements Action {
  readonly type = ManagerCompanyInvitationActionTypes.ManagerCompanyInvitationRemoveSuccess;
  constructor(public payload: UserInvitation) {}
}

export class ManagerCompanyInvitationRemoveFail implements Action {
  readonly type = ManagerCompanyInvitationActionTypes.ManagerCompanyInvitationRemoveFail;
  constructor(public payload: any) {}
}

export class ManagerCompanyInvitationReSend implements Action {
  readonly type = ManagerCompanyInvitationActionTypes.ManagerCompanyInvitationReSend;
  constructor(public payload: UserInvitation) {}
}

export class ManagerCompanyInvitationReSendSuccess implements Action {
  readonly type = ManagerCompanyInvitationActionTypes.ManagerCompanyInvitationReSendSuccess;
  constructor(public payload: UserInvitation[]) {}
}

export class ManagerCompanyInvitationReSendFail implements Action {
  readonly type = ManagerCompanyInvitationActionTypes.ManagerCompanyInvitationReSendFail;
  constructor(public payload: any) {}
}

export class ManagerCompanyInvitationUpdate implements Action{
  readonly type = ManagerCompanyInvitationActionTypes.ManagerCompanyInvitationUpdate;
  constructor(public payload: UserInvitation) {}
}

export type ManagerCompanyInvitationActions =
  | BulkCreateManagerCompanyInvitations
  | BulkCreateManagerCompanyInvitationsSuccess
  | BulkCreateManagerCompanyInvitationsFail
  | ManagerCompanyInvitationsLoadData
  | ManagerCompanyInvitationsLoadSuccess
  | ManagerCompanyInvitationsLoadFail
  | ManagerCompanyInvitationRemove
  | ManagerCompanyInvitationRemoveSuccess
  | ManagerCompanyInvitationRemoveFail
  | ManagerCompanyInvitationReSend
  | ManagerCompanyInvitationReSendSuccess
  | ManagerCompanyInvitationReSendFail
  | ManagerCompanyInvitationUpdate;
